// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"6e205103","213":"fcfab765","301":"e735be34","444":"f50458d5","587":"93e52771","682":"901d2248","732":"c6b68edf"}[chunkId] + ".chunk.js";
};